import { useCurrentUser } from './use-current-user.query';

export const useUserAccount = () => {
  const { data: user } = useCurrentUser();

  return user?.account ?? null;
};
